import { FuelType } from 'src/pages/FuelTracking/enums'
import { FullFuelTrackingProps } from 'src/api/FuelTracking/types'

export enum SortStates {
  BY_NEW = 'BY_NEW',
  BY_ODOMETER = 'BY_ODOMETER',
  BY_FUEL_QUANTITY = 'BY_FUEL_QUANTITY',
  BY_PRICE_PER_LITER = 'BY_PRICE_PER_LITER',
  BY_TOTAL_COST = 'BY_TOTAL_COST',
}

export type Comparator = (
  a: FullFuelTrackingProps,
  b: FullFuelTrackingProps,
) => number

export type ListSorts = {
  type: SortStates
  title: string
}

export type Filters = {
  minOdometer: number | null
  maxOdometer: number | null
  minFuelQuantity: number | null
  maxFuelQuantity: number | null
  fuelType: FuelType | null
  minFuelPricePerLiter: number | null
  maxFuelPricePerLiter: number | null
  minTotalCost: number | null
  maxTotalCost: number | null
}
